import { WorkerActionData } from '@/hooks/useSecWorker';
import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import { animationSliceActions } from '@/modules/animation/slice';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { betRoomSliceActions } from '../../../modules/bet/room/slice';
import {
    getHostByGameId,
    hostsSliceActions,
} from '../../../modules/host/slice';
import store from '../../../store/store';
import { GameState } from '../../games/enums/GameState';
import { CMDScRoundCancel, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScRoundCancelHandler extends AbstractHandler {
    _command: CMDScRoundCancel;
    _registWorkerAction: (item: WorkerActionData) => void;

    constructor(
        command: ICommand,
        registWorkerAction: (item: WorkerActionData) => void
    ) {
        super();
        this._command = command as CMDScRoundCancel;
        this._registWorkerAction = registWorkerAction;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        // const currentGame = getGameState(state);
        const host = getHostByGameId(state, this._command.GameID);
        if (host && host.HostId !== undefined) {
            batch(() => {
                dispatch(
                    hostLiveSliceActions.updateGameState({
                        hostId: host.HostId,
                        state: GameState.RoundCancel,
                    })
                );
                dispatch(
                    hostsSliceActions.updateIsRoundCancel({
                        hostId: host.HostId,
                        isRoundCancel: true,
                    })
                );
                this._registWorkerAction({
                    key: host.HostId.toString(),
                    time: 2,
                    callbackFunc: () => {
                        dispatch(
                            hostsSliceActions.updateIsRoundCancel({
                                hostId: host.HostId,
                                isRoundCancel: false,
                            })
                        );
                    },
                });
                // if (currentGame.currentGameId === this._command.GameID) {
                //     dispatch(gameSliceActions.resetAll());
                // }
                if (host.GameType === GameTypeEnum.CarnivalTreasure) {
                    dispatch(animationSliceActions.reset(host.HostId));
                }
                if (host.GameType === GameTypeEnum.Blackjack2) {
                    dispatch(bj2SeatSliceActions.resetBet(host.HostId));
                    //dispatch(bj2HandSliceActions.reset(host.HostId));
                    //clear in shuffle, round cancel no need
                }
                dispatch(
                    tableBetSliceActions.clearBets({
                        hostId: host.HostId,
                        gameId: this._command.GameID,
                    })
                );
                dispatch(
                    LiveDataSliceActions.updateHostBetInfo({
                        hostId: host.HostId,
                        totalBetAmount: 0,
                        totalWithHoldAmount: 0,
                        pendingBetAmount: 0,
                        pendingWithHoldAmount: 0,
                    })
                );
                // dispatch(
                //     gameSliceActions.setOnceEvent({
                //         gameId: this._command.GameID,
                //         event: 'round_cancel',
                //     })
                // );
                dispatch(betRoomSliceActions.resetBet(host.HostId));
                dispatch(
                    LiveDataSliceActions.updateBaccaratBetHistoryCancel(
                        this._command.GameID
                    )
                );
            });
        }
    }
}
